import type {
  TransitionableStateModelType,
  TransitionableStateValue,
} from "@/entities/state";
import type { ApiError } from "@/services/api";
import type { QueryKey, UseMutationOptions } from "@tanstack/react-query";

import { useMutation, useQueryClient } from "@tanstack/react-query";

import { client } from "@/config/client";

type UseStateTransitionOptions = {
  invalidateKeys?: QueryKey[];
} & Omit<
  UseMutationOptions<unknown, unknown, string>,
  "mutationFn" | "onSuccess"
>;

export const useStateTransition = (
  model: TransitionableStateModelType,
  id: number,
  { invalidateKeys = [], ...mutationsOptions }: UseStateTransitionOptions = {}
) => {
  const queryClient = useQueryClient();
  const clientModel = `${model}s`;

  const mutationFn = (state: TransitionableStateValue) =>
    client[clientModel].transition(id, state);

  const onSuccess = () => {
    queryClient.invalidateQueries({ queryKey: [clientModel] });
    invalidateKeys?.forEach((queryKey) =>
      queryClient.invalidateQueries({ queryKey })
    );
  };

  return useMutation<null, ApiError, TransitionableStateValue>({
    mutationFn,
    onSuccess,
    ...mutationsOptions,
  });
};
